export default function showQuickOptions() {
    (window as any).O365Shell.FlexPane.OpenFlexPaneForProvider('OwaSettings');
}
